import clsx from "clsx";

function Button({ text, onClick, className, disabled, style }) {
  return (
    <div>
      <button
        disabled={disabled}
        onClick={onClick}
        className={clsx(
          "w-full  bg-yellow-rmc_main text-black text-sm  font-semibold rounded-[10px] text-center py-2 px-4",
          disabled ? "opacity-60" : "opacity-100",
          className
        )}
        style={style}
      >
        {text}
      </button>
    </div>
  );
}
export default Button;
